import React from "react";
import Tag from 'components/Tag';
import Artiste from 'components/Artiste';
import Expo from 'components/Expo';
import {ReactComponent as PictoAudio} from 'assets/AUDIO.svg';
import {ReactComponent as PictoGroupe} from 'assets/GROUPE.svg';
import {ReactComponent as PictoImage} from 'assets/IMAGE.svg';
import {ReactComponent as PictoMultimedia} from 'assets/MULTIMEDIA.svg';
import {ReactComponent as PictoVideo} from 'assets/VIDEO.svg';
import {ReactComponent as PictoTexte} from 'assets/TEXTE.svg';

const Utils={
    shuffle: (tab)=> {
        let array=[...tab];
        for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * i)
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array;
    },
    translate: (item,lang,key) => {
        let res=item[key];
        if (item.translations) {
            const tr=item.translations.find((o)=>o.languages_code.code===lang);
            if (tr && tr[key]) res=tr[key];
        }
        return res;
    },
    accentsTidy:function(s) {
        var map = [
            ["[àáâãäå]", "a"],
            ["æ", "ae"],
            ["ç", "c"],
            ["[èéêë]", "e"],
            ["[ìíîï]", "i"],
            ["ñ", "n"],
            ["[òóôõö]", "o"],
            ["œ", "oe"],
            ["[ùúûü]", "u"],
            ["[ýÿ]", "y"],
        ];
        for (var i=0; i<map.length; ++i) {
            s = s.replace(new RegExp(map[i][0], "gi"), ((j)=> {
                return (match) => {
                    if (match.toUpperCase() === match) {
                        return map[j][1].toUpperCase();
                    } else {
                        return map[j][1];
                    }
                }
            })(i));
        }
        return s;
    },
    accentsTidyLw:(s)=>{
        return Utils.accentsTidy(s).toLowerCase();
    },
    type2icon:(t)=>{
        if (t==='images') return 'image';
        if (t==='videos') return 'video';
        if (t==='multimedias') return 'multimedia';
        if (t==='textes') return 'texte';
        if (t==='audios') return 'audio';
        if (t==='groupes') return 'groupe';
    },
    //Cartouches
    renderM2M:(item,key)=>item[key] && item[key].length>0 ? item[key].map((o)=>o[key+'_id']).filter((o)=>Boolean(o)) : [],
    renderExpos:(item)=>{
        const expo=Utils.renderM2M(item,'expositions');
        return [{value:expo.length>0 ? expo.map((e,i)=>e ? <React.Fragment key={e.id}>{i>0 && ', '}<Expo expo={e} toggle={true}/></React.Fragment>: '') : ''}];
    },
    renderArtistes:(item,active=false)=>{
        const artistes=Utils.renderM2M(item,'artistes');
        return {key:'artiste',value:artistes.length>0 ? artistes.map((artiste,i)=><React.Fragment key={artiste.id}>{i>0 && ', '}<Artiste artiste={artiste} active={active}/></React.Fragment>) : ''};
    },
    renderTags:(item)=>{
        const tags=Utils.renderM2M(item,'tags');
        return {key:'tags',value:tags.length>0 ? tags.map((tag,i)=><React.Fragment key={tag.id}>{i>0 && ', '}<Tag tag={tag}/></React.Fragment>) : ''};
    },
    renderVideo:(item,lang) =>[
        {key:'video',value:Utils.translate(item,lang,'name')},
        Utils.renderArtistes(item),
        {key:'duree',value:item.duree},
        {icon:'video'},
    ],
    renderAudio:(item,lang) => [
        {key:'audio',value:Utils.translate(item,lang,'name')},
        Utils.renderArtistes(item),
        {key:'duree',value:item.duree},
        {icon:'audio'},
    ],
    renderImages:(item,lang) =>[
        {key:'images',value:Utils.translate(item,lang,'name')},
        Utils.renderArtistes(item),
        {key:'nombre-d-images',value:item.diaporama && item.diaporama.length},
        {icon:'image'},
    ],
    renderMultimedias:(item,lang) => [
        {key:item.type,value:Utils.translate(item,lang,'name')},
        Utils.renderArtistes(item),
        {key_tr:Utils.translate(item,lang,'stat_key'),value:Utils.translate(item,lang,'stat_value')},
        {icon:Utils.type2icon(item.type)},
    ],
    renderTextes:(item,lang) => [
        {key:'texte',value:Utils.translate(item,lang,'name')},
        Utils.renderArtistes(item),
        {key:'nombre-de-signes',value:item.nb_chars},
        {icon:'texte'},
    ],
    renderItem:(item,lang) => {
        let data=[];
        if (item.__typename==='videos') data=Utils.renderVideo(item,lang);
        if (item.__typename==='audios') data=Utils.renderAudio(item,lang);
        if (item.__typename==='images') data=Utils.renderImages(item,lang);
        if (item.__typename==='multimedias') data=Utils.renderMultimedias(item,lang);
        if (item.__typename==='textes') data=Utils.renderTextes(item,lang);
        return data;
    },
    pictos:{
      audio:PictoAudio,
      groupe:PictoGroupe,
      image:PictoImage,
      multimedia:PictoMultimedia,
      video:PictoVideo,
      texte:PictoTexte,
    },
}
export default Utils;
